export const buildQueryUrl = (url: string, params?: Record<string, any>) => {
  if (!params) {
    return url
  }
  const qs = Object.keys(params)
    .map((key) =>
      params[key] === undefined
        ? false
        : `${key}=${encodeURIComponent(params[key])}`,
    )
    .filter(Boolean)
    .join('&')
  return `${url}?${qs}`
}
